export const STATUS_200 = 200
export const STATUS_400 = 400
export const STATUS_401 = 401
export const STATUS_404 = 404
export const STATUS_405 = 405
export const STATUS_500 = 500
